module.exports = __webpack_public_path__ + "img/category-card-bg-2.2370b179.png";